import React, { FC } from 'react';

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  ['data-testid']?: string;
}

const spinnerClassName = 'relative text-[0.625rem] border-[0.5rem] border-l-secondary-light w-12 h-12 rounded-half border-secondary-snow';

export const Spinner: FC<React.PropsWithChildren<SpinnerProps>> = ({ 'data-testid': dataTestId, className = spinnerClassName }) => (
  <div data-testid={dataTestId} className={`${className} motion-safe:animate-spin`} />
);
